module.exports = __webpack_public_path__ + "static/media/App Launch Otter - spoken english.07a42c30.png";